import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Modal} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import mantenimiento from '../img/mantenimiento.jpg';
import reparadorelectro from '../img/reparador-electro.jpg';
import jardinero from '../img/jardinero.jpg';
import seguridad from '../img/seguridad.jpg';
import fumigador from '../img/fumigador.jpg';
import limpieza from '../img/limpieza.jpg';
import piscina from '../img/piscina.jpg';
import varios from '../img/varios.jpg';
import mantenimiento01 from '../img/albanil1.jpg';
import mantenimiento02 from '../img/albanil2.jpg';
import mantenimiento03 from '../img/albanil3.jpg';
import reparador01 from '../img/reparadora-celular.jpg';
import reparador02 from '../img/reparadora-celular2.jpg';
import jardinero01 from '../img/jardinero1.jpg';
import jardinero02 from '../img/jardinero2.jpg';
import jardinero03 from '../img/jardinero3.jpg';
import reparadortv from '../img/reparador-tv.jpg';
import fumigador1 from '../img/fumigador1.jpg';
import fumigador2 from '../img/fumigador2.jpg';
import piscina1 from '../img/piscina1.jpg';
import piscina2 from '../img/piscina2.jpg';
import domestica1 from '../img/domestica1.jpg';
import domestica2 from '../img/domestica2.jpg';
import domestica3 from '../img/domestica3.jpg';
import gomero from '../img/gomero.jpg';
import cerrajero from '../img/cerrajero.jpg';
import maestroparticular from '../img/maestro-particular.jpg';

const ServiceLink = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const selectedCity = searchParams.get('city') || 'Todas las ciudades';
    const selectedCat = Number(searchParams.get('service')) || 0;

    const [filter, setFilter] = useState(""); // Estado para el filtro de búsqueda
    const [showModal, setShowModal] = useState(false);
    const [selectedService, setSelectedService] = useState(null);

    // Función para abrir el modal con los detalles del servicio
    const handleShow = (service) => {
        setSelectedService(service);
        setShowModal(true);
    };
    const servicesMap = {
        1: { title: "🌟 Servicio de Mantenimiento 🌟", image: mantenimiento, description: "Mantenemos tus espacios en perfectas condiciones con soluciones profesionales.", features: ["Reparaciones preventivas y correctivas.", "Optimización de equipos y estructuras.", "Supervisión y diagnóstico de sistemas.", "Asesoramiento técnico especializado."] },
        2: { title: "🔧 Electricidad y Electrónica 🔧", image: reparadorelectro, description: "Soluciones eléctricas y electrónicas seguras y eficientes.", features: ["Instalación y reparación de sistemas eléctricos.", "Diagnóstico y mantenimiento de equipos electrónicos.", "Soluciones para redes e iluminación.", "Reparaciones seguras y certificadas."] },
        3: { title: "🌿 Jardinería y Exteriores 🌿", image: jardinero, description: "Transformamos y embellecemos tu jardín con un servicio experto.", features: ["Diseño y mantenimiento de jardines.", "Poda y fertilización especializada.", "Instalación de sistemas de riego.", "Control de plagas y enfermedades."] },
        4: { title: "🛡️ Seguridad 🛡️", image: seguridad, description: "Protege tu hogar y empresa con los mejores sistemas de seguridad.", features: ["Sistemas de videovigilancia y alarmas.", "Instalación de cerraduras inteligentes.", "Monitoreo y control de accesos.", "Seguridad física y digital."] },
        5: { title: "🚫 Control de Plagas 🚫", image: fumigador, description: "Eliminamos plagas con métodos seguros y eficaces.", features: ["Fumigación y desinfección profesional.", "Control de roedores e insectos.", "Métodos ecológicos y certificados.", "Prevención y mantenimiento."] },
        6: { title: "🏊‍♂️ Piscinas y Áreas Recreativas 🏊‍♂️", image: piscina, description: "Mantenimiento y reparación de piscinas para que disfrutes sin preocupaciones.", features: ["Limpieza y tratamiento del agua.", "Instalación y reparación de filtros.", "Mantenimiento de estructuras.", "Sistemas de climatización y seguridad."] },
        7: { title: "🧼 Limpieza 🧼", image: limpieza, description: "Ambientes impecables con nuestro servicio de limpieza profesional.", features: ["Limpieza profunda y desinfección.", "Mantenimiento de oficinas y hogares.", "Servicios personalizados.", "Uso de productos ecológicos."] },
        8: { title: "🔄 Servicios Varios 🔄", image: varios, description: "Encuentra soluciones para cualquier necesidad con nuestro equipo experto.", features: ["Reparaciones y mantenimiento general.", "Asesoramiento en múltiples áreas.", "Servicios especializados a medida.", "Atención rápida y personalizada."] }
    };

    const selectedServiceData = servicesMap[selectedCat] || servicesMap[8];

    const hardcodedServices = [
        {
            category: 1,
            title: "Revisión de Instalaciones",
            description: "Revisión completa de equipos y estructuras.",
            image: mantenimiento01,
            name: "Carlos",
            rating: "★★★★☆",
            comments: [
                { customer_name: "María", comment: "Me ayudó con la instalación de cableado. Hizo un trabajo impecable, todo quedó mejor de lo que esperaba." },
                { customer_name: "Javier", comment: "Me ayudó con la reparación de electrodomésticos. Excelente servicio, sin duda lo recomendaré." },
                { customer_name: "Ana", comment: "Me ayudó con la limpieza de piscinas. Muy amable y atento, explicó cada detalle del proceso." }
            ]
        },
        {
            category: 1,
            title: "Reparación de Estructuras",
            description: "Soluciones en albañilería y carpintería.",
            image: mantenimiento02,
            name: "María",
            rating: "★★★★★",
            comments: [
                { customer_name: "Luis", comment: "Me ayudó con la instalación de alarmas. Trabajo limpio y eficiente, volveré a contratarlo." },
                { customer_name: "Sofía", comment: "Me ayudó con la poda de árboles. Superó mis expectativas, gran profesional." }
            ]
        },
        {
            category: 1,
            title: "Pintura y Remodelaciones",
            description: "Mejoramos y renovamos tu espacio.",
            image: mantenimiento03,
            name: "Javier",
            rating: "★★★☆☆",
            comments: [
                { customer_name: "Daniel", comment: "Me ayudó con la pintura y remodelaciones. Servicio rápido y de alta calidad, muy recomendado." },
                { customer_name: "Paula", comment: "Me ayudó con la instalación de cableado. Atención personalizada y un gran resultado final." }
            ]
        },
        {
            category: 2,
            title: "Instalación de Cableado",
            description: "Servicio de cableado eléctrico profesional.",
            image: reparador01,
            name: "Ana",
            rating: "★★★★★",
            comments: [
                { customer_name: "Miguel", comment: "Me ayudó con la reparación de electrodomésticos. Excelente trabajo, muy detallista." },
                { customer_name: "Valeria", comment: "Me ayudó con la instalación de césped. Todo quedó perfecto, gran atención." }
            ]
        },
        {
            category: 2,
            title: "Reparación de Electrodomésticos",
            description: "Solución rápida para equipos dañados.",
            image: reparador02,
            name: "Luis",
            rating: "★★★★☆",
            comments: [
                { customer_name: "Carlos", comment: "Me ayudó con la instalación de alarmas. Rápido y eficiente, lo recomiendo." },
                { customer_name: "María", comment: "Me ayudó con la poda de árboles. Muy buen profesional, cumplió con lo prometido." }
            ]
        },
        {
            category: 3,
            title: "Diseño de Jardines",
            description: "Creamos el jardín de tus sueños.",
            image: jardinero01,
            name: "Sofía",
            rating: "★★★★★",
            comments: [
                { customer_name: "Daniel", comment: "Me ayudó con el diseño de jardines. Un servicio excelente, muy satisfecho." },
                { customer_name: "Paula", comment: "Me ayudó con la poda de árboles. Trabajo impecable, sin dudas lo volvería a contratar." }
            ]
        },
        { category: 3, title: "Poda de Árboles", description: "Mantenimiento profesional para tus árboles.", image: jardinero02, name: "Daniel Herrera", rating: "★★★☆☆" },
        { category: 3, title: "Instalación de Césped", description: "Colocación de césped natural o sintético.", image: jardinero03, name: "Paula Gutiérrez", rating: "★★★★☆" },

        { category: 4, title: "Instalación de Alarmas y Cámaras de Seguridad", description: "Damos seguridad para su familia.", image: reparadortv, name: "Miguel Torres", rating: "★★★★★" },

        { category: 5, title: "Fumigaciones", description: "Fumigaciones profesionales.", image: fumigador1, name: "Valeria Ruiz", rating: "★★★★☆" },
        { category: 5, title: "Fumigaciones", description: "Fumigaciones profesionales.", image: fumigador2, name: "Carlos López", rating: "★★★★☆" },

        { category: 6, title: "Limpieza de Piscinas", description: "Limpieza de piscinas.", image: piscina1, name: "María Pérez", rating: "★★★★★" },
        { category: 6, title: "Mantenimiento de Piscinas", description: "Mantenimiento de Piscinas.", image: piscina2, name: "Javier Gómez", rating: "★★★☆☆" },

        { category: 7, title: "Empleada Doméstica", description: "Empleada Doméstica.", image: domestica1, name: "Ana Rodríguez", rating: "★★★★★" },
        { category: 7, title: "Empleada Doméstica", description: "Empleada Doméstica.", image: domestica2, name: "Luis Martínez", rating: "★★★★☆" },
        { category: 7, title: "Empleada Doméstica", description: "Empleada Doméstica.", image: domestica3, name: "Sofía Fernández", rating: "★★★★★" },

        { category: 8, title: "Gomería autos, motos, bicis", description: "Gomería Autos, motos, bicis.", image: gomero, name: "Daniel Herrera", rating: "★★★☆☆" },
        { category: 8, title: "Cerrajeria en general", description: "Cerrajeria en general.", image: cerrajero, name: "Paula Gutiérrez", rating: "★★★★☆" },
        { category: 8, title: "Maestro Particular Inglés", description: "Maestro Particular Inglés.", image: maestroparticular, name: "Miguel Torres", rating: "★★★★★" },
    ];

    const filteredServices = hardcodedServices
        .filter(service => service.category === selectedCat)
        .filter(service => service.title.toLowerCase().includes(filter.toLowerCase()));

    return (
        <Container className="my-5 local-hire-design position-relative">
            <h5 className="text-primary fw-bold text-center font-montserrat">Servicios en {selectedCity}</h5>
            <Row>
                <Col md={5} className="mb-4">
                    <Card className="shadow-lg p-2 border-0">
                        <Card.Body>
                            <Card.Title className="text-center text-primary fw-bold">{selectedServiceData.title}</Card.Title>
                            <Card.Text className="mt-3 text-muted">{selectedServiceData.description}</Card.Text>
                            <ul>
                                {selectedServiceData.features.map((feature, index) => (
                                    <li key={index}>{feature}</li>
                                ))}
                            </ul>
                            <div className="text-center mt-4">
                                <Button variant="success" size="sm">📞 Contáctanos hoy</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={7} className="mb-4">
                    <img src={selectedServiceData.image} alt="Servicio" className="img-fluid rounded" />
                </Col>
            </Row>

            {/* Campo de Búsqueda */}
            <Form.Control
                type="text"
                placeholder="Buscar servicio..."
                className="mb-4"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
            />

            {/* Sección de Cards Filtradas */}
            <Row>
                {filteredServices.map((service, index) => (
                    <Col md={4} key={index} className="mb-4">
                        <Card className="shadow-sm border-0 rounded-lg">
                            <Row className="g-0 align-items-center">
                                <Col xs={4} className="text-center">
                                    <Card.Img variant="left" src={service.image} alt={service.title} className="rounded img-fluid" style={{ width: "100px", margin: "0 auto" }} />
                                </Col>
                                <Col xs={8}>
                                    <Card.Body>
                                        <Card.Title className="text-primary fw-bold">{service.title}</Card.Title>
                                        <Card.Text className="text-muted">{service.description}</Card.Text>
                                        <Card.Text className="fw-bold">{service.name}</Card.Text>
                                        <Card.Text className="text-warning">{service.rating}</Card.Text>
                                        <Button variant="primary" className="mt-2 rounded-pill px-4"
                                            onClick={() => handleShow(service)}
                                        >
                                            Ver más
                                        </Button>
                                    </Card.Body>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                ))}
            </Row>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary">{selectedService?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedService && (
                        <>
                            <div className="text-center">
                                <img
                                    src={selectedService.image}
                                    alt={selectedService.title}
                                    className="img-fluid rounded mb-3"
                                    style={{ maxWidth: "150px" }}
                                />
                            </div>
                            <h5 className="text-center text-warning">{selectedService.rating}</h5>
                            <p className="text-muted"><strong>Servicio:</strong> {selectedService.title}</p>
                            <p className="text-muted"><strong>Descripción:</strong> {selectedService.description}</p>

                            <h6 className="fw-bold mt-3">Reseñas de clientes:</h6>
                            <ul className="list-unstyled">
                                {selectedService.comments?.map((review, i) => (
                                    <li key={i} className="mb-2">
                                        <strong>{review.customer_name}:</strong> {review.comment}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="mt-2 rounded-pill px-4">
                        Contratar
                    </Button>
                    <Button variant="secondary" className="mt-2 rounded-pill px-4" onClick={() => setShowModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default ServiceLink;
